export default __webpack_public_path__ + "static/media/MUSIC_01.bb9e6dfb.jpg";